/*
 * @Author: seven.zhang 
 * @Date: 2019-02-21 18:16:48 
 * @Last Modified by: seven.zhang
 * @Last Modified time: 2019-02-28 17:19:29
 * 静态枚举值配置
 */

const staticEnum = {
    // 时间
    timeList:[
        {value:0,label:'近7天'},
        {value:1,label:'近1个月'},
        {value:2,label:'近6个月'},
        {value:3,label:'近12个月'},
    ],

    // 土地现状
    landStatus:[
        {value:1,label:'未开工'},
        {value:2,label:'部分开工'},
        {value:3,label:'全部开工'},
    ],
    // 土地属性
    landUseType:[
        { value: 1, label: '纯住宅'},
        { value: 2, label: '商住'},
        { value: 3, label: '商办'},
        { value: 4, label: '综合'},
        { value: 5, label: '工业'},
        { value: 6, label: '其他'},
    ],

    // 销售状态
    saleStatus:[
        { value: 1, label: '未公开'},
        { value: 2, label: '形象'},
        { value: 3, label: '在售'},
        { value: 4, label: '售罄'},
        { value: 5, label: '烂尾楼'},
        { value: 6, label: '预售'},
        { value: 7, label: '尾盘'},
    ],
    // 物业类型                  
    propertyType:[
        { value: 1, label: '普通住宅'},
        { value: 2, label: '别墅'},
        { value: 3, label: '酒店式公寓'},
        { value: 4, label: '经济适用房'},
        { value: 5, label: '动迁安置房'},
        { value: 6, label: '配套商品房'},
        { value: 7, label: '限价房'},
    ],
    // 装修情况                          
    decorationType:[
        { value: 1, label: '毛坯'},
        { value: 2, label: '全装修'},
    ],
     
}
export default staticEnum
